import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store";
import { DeviceTestStatusEnum } from "pages/jobs/jobDetails/visit/inspection/DeviceTestStatusEnum";

interface InspectionResultsState {
  resultsBySpecificationId: Record<string, DeviceTestStatusEnum>;
}

export type State = InspectionResultsState;

const initialState: InspectionResultsState = {
  resultsBySpecificationId: {},
};

const inspectionResultsSlice = createSlice({
  name: "inspectionResults",
  initialState,
  reducers: {
    setInspectionResult: (
      state,
      action: PayloadAction<{
        specificationId: string;
        result: DeviceTestStatusEnum;
      }>
    ) => {
      state.resultsBySpecificationId[action.payload.specificationId] =
        action.payload.result;
    },

    clearInspectionResult: (state, action: PayloadAction<string>) => {
      delete state.resultsBySpecificationId[action.payload];
    },

    clearAllInspectionResults: () => initialState,
  },
});

export const {
  setInspectionResult,
  clearInspectionResult,
  clearAllInspectionResults,
} = inspectionResultsSlice.actions;

export const selectInspectionResult =
  (specificationId: string) => (state: RootState) =>
    state.inspectionResults.resultsBySpecificationId[specificationId];

export const selectAllInspectionResults = (state: RootState) =>
  state.inspectionResults.resultsBySpecificationId;

export default inspectionResultsSlice.reducer;
